import { memo } from 'react'
import useI18n from 'src/hooks/use_i18n'
import { CarrierInfoMarkDTO } from 'src/types'
import { filterRegex } from 'src/utils/carriers_info'

// #region component
interface Props {
  carrierName?: string
  carriersInfoData?: any
  carrierInfoMark: CarrierInfoMarkDTO
  totalCarriersStr: number | string
}

function WhoIsUse({ carriersInfoData, carrierInfoMark, totalCarriersStr, carrierName = '17track' }: Props) {
  const { $t, i18nFormatAll } = useI18n()

  return (
    <>
      <div itemProp="mainEntity" itemScope itemType="https://schema.org/Question">
        <h2 id={filterRegex('using' + carrierName, /[ ?]/g, '-')} itemProp="name">
          {carriersInfoData?.commonConfig?.whoUsing ??
            i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pWhoIsUseProblem'), {
              carriersName: carrierName
            })}
        </h2>
        <div itemProp="acceptedAnswer" itemScope itemType="https://schema.org/Answer">
          <div itemProp="text">
            <p>
              {i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pWhoIsUse_answer1'), {
                countryNums: i18nFormatAll($t('ResWwwPHome.global.__score_totalVar'), [carrierInfoMark?.country]),
                carriersNums: totalCarriersStr
              })}
            </p>
            <p>
              {i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pWhoIsUse_answer2'), {
                carriersName: carrierName
              })}
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default memo(WhoIsUse)
